import { getScrollParams as createResumeScrollParams } from 'src/components/Profile/CreateResume/consts';
import { CREATE_RESUME_PAGE } from 'src/components/Router';
import type { ReduxInjections } from 'src/types';

import {
  UPDATE_ROUTE,
  UPDATE_PAGE,
  START_SCROLL,
  END_SCROLL,
  type RouterAction,
  type UpdateRouteParams,
  type UpdatePageParams,
  type State as RouterState,
  SET_ALL_ROUTES,
  RESET_ROUTES,
} from './reducer';

export const updateRoute =
  ({ to, mode, params = {}, analytics }: UpdateRouteParams) =>
  ({
    dispatch,
    getState,
  }: ReduxInjections<Extract<RouterAction, { type: 'UPDATE_ROUTE' }>>) => {
    let updateRouteParams = params;

    const {
      router: { page },
    } = getState();

    if (page === CREATE_RESUME_PAGE) {
      updateRouteParams = {
        ...createResumeScrollParams(),
        ...updateRouteParams,
      };
    }

    return dispatch({
      type: UPDATE_ROUTE,
      payload: {
        to,
        mode,
        params: updateRouteParams,
        analytics,
      },
      meta: {
        metrics: {
          to,
          mode,
          ...analytics,
        },
      },
    });
  };

export const updatePage = ({
  page,
  params = {},
  analytics,
}: UpdatePageParams): RouterAction => ({
  type: UPDATE_PAGE,
  payload: {
    page,
    params,
    analytics,
  },
  meta: {
    metrics: {
      page,
    },
  },
});

export const setAllRoutes = (router: RouterState): RouterAction => ({
  type: SET_ALL_ROUTES,
  payload: router,
});

export const resetRoutes = (): RouterAction => ({ type: RESET_ROUTES });

export const startScroll = (): RouterAction => ({ type: START_SCROLL });

export const endScroll = (): RouterAction => ({ type: END_SCROLL });
